import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const SetmoreRedirect = () => {
  const setmoreUrl = "https://nearlabservicesllc.setmore.com";

  useEffect(() => {
    // Redirect to Setmore booking page
    window.location.href = setmoreUrl;
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-light via-blue-light/50 to-green-light/50 flex items-center justify-center">
      <div className="text-center p-8 bg-white/90 backdrop-blur-sm rounded-xl shadow-xl border border-white/50">
        <Loader2 className="w-8 h-8 animate-spin text-blue-primary mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Redirecting to Booking System</h2>
        <p className="text-gray-600 mb-4">Taking you to our appointment scheduling system...</p>
        <p className="text-sm text-gray-500">
          If you're not redirected automatically, 
          <a 
            href={setmoreUrl}
            className="text-blue-primary hover:underline ml-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            click here
          </a>
        </p>
      </div>
    </div>
  );
};

export default SetmoreRedirect;